<app-offer-table [theme]="theme" />
